/** @jsxImportSource @emotion/react */
import React from "react";
import { useTranslation } from "react-i18next";
import Colors from "styles/colors";
import { Separator } from "components/atoms/Separator.atom";
import { SeparatorOrientation } from "components/atoms/enums";
import { ReportsListItemButton } from "pages/reports/bi-dashboard-next/components/molecules/Reports.ListItemButton.molecule";
import { ReportsTagsList } from "pages/reports/bi-dashboard-next/components/organisms/Reports.TagsList.organism";

interface ReportsLeftNavbarProps {
  selectedTags: string[];
  criteria: any;
  onAllClick: () => void;
  onTagClick: (tag: any) => void;
  onArchiveClick: () => void;
  onRecentlyAddedClick: () => void;
  onFavoritesClick: () => void;
  onScheduledEmailClick: () => void;
  onOpenedThisWeekClick: () => void;
}

export const ReportsLeftNavbar: React.FC<ReportsLeftNavbarProps> = ({
  selectedTags,
  criteria,
  onAllClick,
  onTagClick,
  onArchiveClick,
  onRecentlyAddedClick,
  onFavoritesClick,
  onScheduledEmailClick,
  onOpenedThisWeekClick,
}) => {
  const { t } = useTranslation("reports");

  return (
    <div
      css={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: Colors.biDashboardView.CARD_BACKGROUND,
        boxShadow: Colors.biDashboardView.LEFT_NAVBAR_BOX_SHADOW,
        flex: 1,
        minHeight: 0,
        overflow: "auto",
        transition: "all .5s ease-in-out",
        "::-webkit-scrollbar": {
          width: 4,
          background: Colors.biDashboardView.SCROLLBAR_BACKGROUND,
        },
        "::-webkit-scrollbar-thumb": {
          background: Colors.biDashboardView.SCROLLBAR_THUMB,
          borderRadius: 4,
        },
        "::-webkit-scrollbar-thumb:hover": {
          background: Colors.biDashboardView.SCROLLBAR_THUMB_HOVER,
        },
        "::-webkit-scrollbar-corner": {
          background: "transparent",
        },
        "::-webkit-scrollbar-button": {
          display: "none",
          height: 0,
        },
      }}
    >
      <ReportsListItemButton
        text={t("All")}
        isActive={
          selectedTags.length === 0 &&
          !criteria.nameLike &&
          !criteria.detailsLike &&
          criteria.enabled !== false &&
          !criteria.createdAtFrom &&
          criteria.favorited !== true &&
          criteria.hasEmailSchedules !== true &&
          !criteria.reportIdsIn &&
          !criteria.reportNumbersIn
        }
        onClick={onAllClick}
      />
      <ReportsListItemButton
        text={t("Favorites")}
        isActive={criteria.favorited === true}
        onClick={onFavoritesClick}
      />
      <ReportsListItemButton
        text={t("Recently Added")}
        isActive={!!criteria.createdAtFrom}
        onClick={onRecentlyAddedClick}
      />
      <ReportsListItemButton
        text={t("Reports Opened This Week")}
        isActive={!!criteria.reportIdsIn || !!criteria.reportNumbersIn}
        onClick={onOpenedThisWeekClick}
      />
      <ReportsListItemButton
        text={t("Reports Scheduled For Email")}
        isActive={criteria.hasEmailSchedules === true}
        onClick={onScheduledEmailClick}
      />
      <Separator
        orientation={SeparatorOrientation.HORIZONTAL}
        color={Colors.text.VERY_LIGHT_GRAY}
        css={{
          margin: "10px",
        }}
      />
      <ReportsTagsList
        onTagClick={onTagClick}
        selectedTags={selectedTags}
        onClearAllTags={onAllClick}
      />
    </div>
  );
};
